import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import QrImg from "../../../../../assets/QrImg.png";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  creatingShareBlock,
  resetUser,
} from "../../../../../redux/slices/block/createBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";

import { toast } from "react-hot-toast";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

const QrCode = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, allLangs, tComponent, handleLanguageChange } =
    useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  // Qr
  const qrCheck = blockFeature?.some(
    (item) => item.name === "share" && paymenetBlocks === 1
  );
  useEffect(() => {
    if (!qrCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const selector = useSelector((store) => store?.shareQRCode?.shareBlock);

  // data needed for calling fetching list
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.user_id;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };

  const [subLoader, setSubLoader] = React.useState(false);

  const handleShareSubmit = async (e) => {
    e.preventDefault();

    setSubLoader(true);

    const state = {
      coloum_type: "share",
      coloum_value: selector,
      coloum_name: "share",
      language: selectedLang,
    };

    await dispatch(creatingShareBlock(state));

    setSubLoader(false);
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
  };
  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const { shareUserSuccess, shareUserError, shareUserLoading } = useSelector(
    (state) => state?.blockHeading
  );

  const { status } = useSelector(
    (state) => state?.blockHeading?.shareUserState
  );

  useEffect(() => {
    if (status === "success" && shareUserSuccess) {
      toast.success("Share Block Inserted");
      navigate("/dashboard");
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shareUserError, shareUserSuccess, dispatch, shareUserLoading]);

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
          <Link to={"/dashboard/component"}>
            <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
              <div>
                {darkMode ? (
                  <LeftArrowDark
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <LeftArrow
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
              <p className="dark:text-color_v1_dark">
                {translate("Qr_code")}
              </p>
            </div>
          </Link>
        </div>
        <div
          className="pt-[50px] md:px-0 pb-6 sm:pt-[28px] px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 border-light_bg_v2 p-6 sm:p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {tComponent("qr_code.add")} {tComponent("qr_code.Qr_code")}
              </p>
              <div className="flex items-center justify-center">
                <div className="relative w-[115px] sm:w-[145px]">
                  <div
                    onClick={() => {
                      setSelectReporterTypeDropDown(
                        !selectReporterTypeDropDown
                      );
                    }}
                    className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                  >
                    {selectedReporterType
                      ? selectedReporterType
                      : tComponent("qr_code.select_lang")}
                    <DownArrow />
                  </div>
                  {selectReporterTypeDropDown && (
                    <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                      {allLangs?.map((item, i) => {
                        return (
                          <div
                            key={i}
                            onClick={() => {
                              setSelectedLang(item.value); // Set selected language code
                              setSelectedReporterType(item?.label);
                              setSelectReporterTypeDropDown(false);
                              handleChangeLang(item?.value);
                            }}
                            className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                          >
                            {item.label}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="bg-light_bg_v4 rounded-lg p-10 sm:p-[30px]">
              <div className="flex items-center justify-center w-full">
                <img src={QrImg} alt="" />
              </div>
            </div>
            <div className="flex mt-[26px] items-center justify-end">
              <div className="flex justify-center items-center">
              {darkMode ? <TrashIconDark /> : <TrashIcon />}
              <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark uppercase">
                  {tComponent("qr_code.delete_cap")}
                </p>
              </div>
              <button
                onClick={handleShareSubmit}
                className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b uppercase ${
                  subLoader ? "bg-opacity-70" : ""
                }`}
                disabled={subLoader}
              >
                {subLoader ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-3 h-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  tComponent("qr_code.save_cap")
                )}
              </button>
            </div>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default QrCode;
